import React, { useState } from 'react'
import { usePathname } from 'next/navigation'
import { useScrollPosition } from '@dustin-web/microsite-components/src/hooks/use-scroll-position'
import { scrollToTop } from '@dustin-web/microsite-components/src/utils/scroll-to-top'
import Icon from '@dustin-web/microsite-components/src/icon'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'

const ScrollToTopButton = () => {
  const [show, setShow] = useState(false)
  const { enabled } = useFeatureFlag('ab-test-product-sticky-add-to-cart')
  const pathname = usePathname()

  const isProductPageTestEnabled = enabled && pathname.includes('product/')

  useScrollPosition(({ currPos }) => {
    const shouldShow = currPos.y < -500
    const rerenderNeeded = shouldShow !== show

    if (shouldShow && rerenderNeeded) {
      setShow(true)
    } else if (!shouldShow && rerenderNeeded) {
      setShow(false)
    }
  })

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault()
    scrollToTop()
  }

  return (
    <>
      {show && !isProductPageTestEnabled && (
        <a
          id="scroll-to-top-btn"
          href="#"
          className="c-scroll-to-top-btn"
          onClick={onClick}
          aria-label="Scroll to top">
          <Icon name="arrow-up" />
        </a>
      )}
    </>
  )
}

export default ScrollToTopButton
